import { list } from './tags';

function endpoints(builder, tefafApi) {
  return {
    getCollectorFavourites: builder.query({
      query: (fairId) => `tefaf/collectorportal/favourites/list/${fairId}`,
      providesTags: list,
      transformResponse: (response) => {
        const favourites = {};
        response.favourites.forEach((artObject) => {
          favourites[artObject.id] = artObject;
        });

        return { ...response, favourites };
      },
    }),
    toggleCollectorFavourite: builder.mutation({
      invalidatesTags: (result, error) => (error ? list : []),
      query: (values) => {
        const body = new FormData();
        if (values.csrfParam && values.csrfToken) {
          body.append(values.csrfParam, values.csrfToken);
        }
        body.append('action', 'tefaf/collectorportal/favourites/toggle-favourite');
        body.append('collectingGuideId', (values.collectingGuideId || ''));
        body.append('fairId', (values.fairId || ''));
        body.append('artObjectId', (values.artObjectId || ''));
        body.append('email', (values.email || ''));
        if (Object.hasOwn(values, 'favourite')) {
          body.append('favourite', values.favourite);
        }
        if (Object.hasOwn(values, 'visited')) {
          body.append('visited', values.visited);
        }
        body.append('newsletter', !!(values.newsletter && values.newsletter.length > 0));

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
      onQueryStarted(data, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          tefafApi.util.updateQueryData('getCollectorFavourites', data.fairId, (draft) => {
            if (!draft.account.email) {
              draft.account.email = data.email;
            }
            if (data.artObjectId) {
              const favoriteExists = !!(draft.favourites[data.artObjectId] || null);
              if (!favoriteExists) {
                draft.favourites[data.artObjectId] = {
                  id: data.artObjectId,
                  favourite: false,
                  visited: false,
                };
              }
              if (Object.hasOwn(data, 'favourite')) {
                draft.favourites[data.artObjectId] = {
                  ...draft.favourites[data.artObjectId],
                  favourite: data.favourite,
                };
              }
              if (Object.hasOwn(data, 'visited')) {
                draft.favourites[data.artObjectId] = {
                  ...draft.favourites[data.artObjectId],
                  visited: data.visited,
                };
              }
            }
          }),
        );
        queryFulfilled.catch(patchResult.undo);
      },
    }),
  };
}

export { endpoints };
